import React, { ReactNode } from 'react';
import Tooltip from './Tooltip';
import { useTranslation } from 'react-i18next';
import DetailIcon from '../icon/DetailIcon';

interface ActionButtonsProps {
    onView?: () => void,
    otherComponent?: ReactNode,
    className?: string
}

const TableActionButtons: React.FC<ActionButtonsProps> = ({
    onView,
    otherComponent,
    className = ''
}) => {
    // hook
    const { t } = useTranslation();

    return (
        <div className={`flex gap-x-3 w-full h-fit ${className}`}>
            {onView && (
                <Tooltip content={t('button.detail')} triggerAsChild>
                    <div
                        // type='button'
                        onClick={onView}
                        className='cursor-pointer w-fit h-fit'
                    >
                        <div className='relative inline-block group'>
                            {/* <div className='absolute inset-0 bg-transparent group-hover:bg-gray-300 transition-colors z-[-1] rounded-full' /> */}
                            <DetailIcon width={20} height={20} />
                        </div>
                    </div>
                </Tooltip>
            )}
            {otherComponent}
        </div>
    );
};

export default TableActionButtons;
